// extracted by mini-css-extract-plugin
export default {"schedule":"Schedule_schedule__elg-a","title":"Schedule_title__gL1m7","tableWrap":"Schedule_tableWrap__rWeup","btn":"Schedule_btn__EcFB2"};